<template>
  <div class="child-page-div">
    <div class="page-content-div">
      <table-box ref="tableBox" tableTitle="招聘标签管理" :tableFieldNum="tableFieldNum" :action="action" :params="queryParams" :reloadData.sync="reloadData">
        <template #title-right>
          <div class="search-div">
            <label>
              <select v-model="searchType">
                <option value="0">所有</option>
                <option value="1">招聘</option>
                <option value="2">求职</option>
                <option value="3">维修教学</option>
              </select>
            </label>
            <input class="search-btn" type="button" value="搜索" @click="onSearch" />
          </div>
        </template>
        <template #table-head>
          <th v-for="(item, index) in tableField" v-show="item.state" :key="index">{{ item.alias }}</th>
          <th v-if="isOperation" class="operation-th">操作</th>
        </template>
        <template v-if="$validateAuthority(2700000,2716000,2716001)" #tableSubHead>
          <th class="table-sub-head-th" :colspan="tableFieldNum">
            <div class="div-btn cursor-el append-btn" @click="onShowAdd">
              <img src="../../assets/add-data.png" height="14" width="14" alt="" />
              <label class="cursor-el">添加标签</label>
            </div>
          </th>
        </template>
        <template #table-body="props">
          <tr>
            <template v-for="(item, index) in tableField">
              <td v-if="item.isHtml" :key="index" v-show="item.state" v-html="item.value(props.item, item.name)" />
              <td v-else :key="index" v-show="item.state">{{ item.value(props.item, item.name) }}</td>
            </template>
            <td v-if="isOperation">
              <div class="operation-btn-div">
                <span v-if="$validateAuthority(2700000,2716000,2716002)" class="cursor-el" @click="onShowEdit(props.item)">编辑</span>
              </div>
            </td>
          </tr>
        </template>
      </table-box>
    </div>
  </div>
</template>

<script>
import TableBox from "../../components/TableBox";
import RecruitTagAddLayer from "../layer/RecruitTagAddLayer";
import RecruitTagEditLayer from "../layer/RecruitTagEditLayer";
import { getRecruitTagItems } from "@/common/api";

export default {
  name: "RecruitTags",
  components: { TableBox },
  data() {
    return {
      action: getRecruitTagItems,
      reloadData: false,
      searchType: "0",
      queryParams: {
        type: 0,
        msg: "",
        pageSize: 20
      },
      tableField: [
        { state: true, alias: "编号", name: "id", title: "id", isHtml: false, value: this.getObjValue },
        { state: true, alias: "分类", name: "type", title: "type", isHtml: false, value: this.getObjValue },
        { state: true, alias: "名称", name: "name", title: "name", isHtml: false, value: this.getObjValue },
        { state: true, alias: "创建人", name: "creator", title: "creator", isHtml: false, value: this.getObjValue },
        { state: true, alias: "创建时间", name: "createTime", title: "createTime", isHtml: false, value: this.getObjValue }
      ]
    };
  },
  computed: {
    isOperation() {
      return this.$hasAuthority(2700000,2716000,[2716002]);
    },
    tableFieldNum() {
      let num = this.isOperation ? 1 : 0;
      this.tableField.forEach(function(value) {
        if (value.state) {
          ++num;
        }
      });
      return num;
    }
  },
  methods: {
    getObjValue(item, field) {
      if(field === "type"){
        return this.getTagName(item[field]);
      }else{
        return item[field];
      }
    },
    onReloadData() {
      this.reloadData = true;
    },
    onSearch() {
      this.queryParams.type = this.searchType;
    },
    onShowAdd() {
      this.$layer.iframe({
        content: {
          content: RecruitTagAddLayer,
          parent: this,
          data: {
            refreshData: this.onReloadData
          }
        },
        area: ["600px", "300px"],
        title: "添加标签"
      });
    },
    onShowEdit(item) {
      this.$layer.iframe({
        content: {
          content: RecruitTagEditLayer,
          parent: this,
          data: {
            tagId: item.id,
            tagType: this.getTagName(item.type),
            tagValue: item.name,
            refreshData: this.onReloadData
          }
        },
        area: ["600px", "300px"],
        title: "编辑标签"
      });
    },
    getTagName(type) {
      switch (type) {
        case 1: return "招聘";
        case 2: return "求职"
        case 3: return "维修教学"
        default: return "未知"
      }
    }
  }
}
</script>

<style lang="less" scoped>
.child-page-div {
  width: 100%;
  .page-content-div {
    border-radius: 5px;
    background-color: #ffffff;
    padding: 30px 20px 10px 20px;
    .search-div {
      height: 100%;
      display: flex;
      select {
        width: 110px;
        height: 100%;
        border: 1px solid #dcdcdc;
      }
      .state-label {
        margin-left: 5px;
        margin-right: 10px;
      }
      .search-input {
        width: 140px;
        height: 33px;
        border: 1px solid #dcdcdc;
        padding: 0 15px;
        margin-left: 5px;
      }
      .search-btn {
        width: 80px;
        height: 100%;
        color: #f4f6f5;
        border: none;
        background: #4676c8;
      }
    }
    .operation-th {
      width: 80px;
    }
    .table-sub-head-th {
      .div-btn {
        float: left;
        width: 88px;
        height: 23px;
        border: 1px solid #e5e5e5;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          margin-right: 10px;
        }
      }
      .append-btn {
        margin-left: 15px;
        margin-right: 10px;
      }
    }
    .operation-btn-div {
      display: flex;
      justify-content: space-around;
    }
  }
}
</style>